module.exports = __webpack_public_path__ + "static/img/khk002a-pi.a9a44678.jpg";